import React from "react";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Toranam } from "@/components/Ornaments";
import { Button } from "@/components/ui/button";

export default function Contact() {
  const { t, settings } = useApp();
  const phone = settings?.helpline_phone || "9603333685";
  const email = settings?.support_email || "contact@devalayabandham.com";
  const founder = settings?.founder_name || "బాచరాజు వరుణ్ కుమార్";
  return (
    <div className="parchment-texture min-h-screen">
      <div className="bg-gradient-to-r from-maroon to-saffron py-12 text-center">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-white">{t("nav_contact")}</h1>
        <p className="text-white/85 font-telugu mt-2">ఏవైనా సందేహాలకు మమ్మల్ని సంప్రదించండి</p>
      </div>
      <Toranam />
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="bg-surface rounded-2xl gold-border temple-shadow p-8 text-center">
          <div className="text-4xl mb-2">🙏</div>
          <h2 className="font-display text-xl font-bold text-maroon">{founder}</h2>
          <p className="text-sm text-saffron font-telugu">వ్యవస్థాపకులు & నిర్వాహకులు</p>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            <a data-testid="contact-call" href={`tel:${phone}`} className="p-5 rounded-xl border border-goldline/40 hover:bg-marigold/10 flex flex-col items-center gap-2">
              <Phone className="w-6 h-6 text-saffron" /><span className="font-semibold text-maroon">{phone}</span><span className="text-xs text-muted-foreground font-telugu">{t("call_now")}</span>
            </a>
            <a data-testid="contact-whatsapp" href={`https://wa.me/91${phone}`} target="_blank" rel="noreferrer" className="p-5 rounded-xl border border-goldline/40 hover:bg-marigold/10 flex flex-col items-center gap-2">
              <MessageCircle className="w-6 h-6 text-[#25D366]" /><span className="font-semibold text-maroon">WhatsApp</span><span className="text-xs text-muted-foreground font-telugu">సందేశం పంపండి</span>
            </a>
            <a data-testid="contact-email" href={`mailto:${email}`} className="p-5 rounded-xl border border-goldline/40 hover:bg-marigold/10 flex flex-col items-center gap-2">
              <Mail className="w-6 h-6 text-saffron" /><span className="font-semibold text-maroon text-sm break-all">{email}</span><span className="text-xs text-muted-foreground font-telugu">{t("email")}</span>
            </a>
            <div className="p-5 rounded-xl border border-goldline/40 flex flex-col items-center gap-2">
              <MapPin className="w-6 h-6 text-saffron" /><span className="font-semibold text-maroon font-telugu">ఆంధ్రప్రదేశ్ & తెలంగాణ</span><span className="text-xs text-muted-foreground font-telugu">సేవా ప్రాంతం</span>
            </div>
          </div>
          <Button data-testid="contact-help-wa" onClick={() => window.open(`https://wa.me/91${phone}`, "_blank")} className="btn-sacred border-0 mt-8 font-telugu px-8">
            {t("help_contact")}
          </Button>
        </div>
      </div>
    </div>
  );
}
